(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boa-video-with-text-sides"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", boaHandleAutoPlayVideo);

function boaAddAnimationForText(text, content) {
    if (!text) return;
    text.classList.remove("animate-exit");
    if (!text.classList.contains("animate")) {
        text.classList.add("animate");
    }
    if (!content) return;
    content.classList.remove("animate-exit");
    if (!content.classList.contains("animate")) {
        content.classList.add("animate");
    }
}

function boaAddExitAnimationForText(text, content) {
    if (!text) return;
    const textStyle = window.getComputedStyle(text);
    textStyle.opacity === "1" && text.classList.add("animate-exit");
    text.classList.remove("animate");

    if (!content) return;
    const contentStyle = window.getComputedStyle(content);
    contentStyle.opacity === "0.6" && content.classList.add("animate-exit");
    content.classList.remove("animate");
}

function boaHandleAutoPlayVideo() {
    const boaVideos = document.querySelectorAll(".boa-video-with-text video");
    const boaImagesWithText = document.querySelectorAll(".boa-video-with-text .image");

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const media = entry.target;
            let isVideo = false;
            if (media.tagName === 'VIDEO') {
                isVideo = true;
            }
            const text = media.closest('.media-wrap')?.querySelector('.text-container');
            const content = media.closest('.media-wrap')?.querySelector('.content');
            const isTitleOnly = text?.classList.contains('title-only');
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
                if (isVideo && !(media.dataset.playOnce === 'true' && media.dataset.alreadyPlayed === 'true')) {
                    media.play();
                    boaAddAnimationForVideo(entry);
                    // ended only fires when loop is off; play_once is ignored while looping
                    if (media.dataset.playOnce === 'true' && !media.loop) {
                        media.addEventListener('ended', function () {
                            media.dataset.alreadyPlayed = 'true';
                        }, { once: true });
                    }
                }
                if (!isTitleOnly && text) {
                    boaAddAnimationForText(text, content);
                }
            } else {
                if (text && entry.intersectionRatio > 0 && entry.intersectionRatio < 0.25 && !isTitleOnly) {
                    boaAddExitAnimationForText(text, content);
                }
                if (entry.intersectionRatio < 0.5 && media.readyState > 2) {
                    media.pause();
                    if (media.dataset.playOnce !== 'true') {
                        media.currentTime = 0;
                    }
                    boaRemoveAnimationForVideo(entry);
                }
            }
        });
    }, {
        threshold: [0.25]
    });

    boaVideos?.forEach(video => observer.observe(video));
    boaImagesWithText?.forEach(image => observer.observe(image));
}

function boaAddAnimationForVideo(video) {
    video.target.classList.add('animate');
    const videoWrap = video.target.closest('.video-wrapper');
    videoWrap?.classList.add('animate');
}

function boaRemoveAnimationForVideo(video) {
    video.target.classList.remove('animate');
    const videoWrap = video.target.closest('.video-wrapper');
    videoWrap?.classList.remove('animate');
}

document.addEventListener("DOMContentLoaded", boaHandleTextsTransition);

function boaHandleTextsTransition() {
    const textSides = document.querySelectorAll(".boa-video-with-text-sides .sides");
    if (!textSides.length) return;
    boaHandleTitleAnimation();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const ratio = boaCalculateRatio(entry);
            entry.target.style.opacity = ratio;
        });
    }, {
        threshold: Array.from({ length: 101 }, (_, i) => i / 100)
    });

    textSides.forEach(textSide => observer.observe(textSide));
}

function boaHandleTitleAnimation() {
    const videoCover = document.querySelectorAll(".boa-video-with-text-sides .video-cover");
    if (!videoCover.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const title = entry.target.closest('.boa-video-with-text-sides')?.querySelector('.text-container.title-only');
            if (!title) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
                boaAddAnimationForText(title);
            }
            if (entry.intersectionRatio < 0.7) {
                boaAddExitAnimationForText(title);
            }
        });
    }, {
        threshold: Array.from({ length: 11 }, (_, i) => i / 10)
    });

    videoCover.forEach(textSide => observer.observe(textSide));
}

function boaCalculateRatio(entry) {
    let ratio = entry.intersectionRatio;
    if (ratio <= 0.7) {
        ratio = ratio - 0.2;
    }
    return ratio;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venture-cta-bar"]) return;
  try {
    
let ventureCtaBarBound = false;

function initVentureCtaBar() {
	const mobileMq = window.matchMedia('(max-width: 1000px)');
	let ticking = false;

	function update() {
		ticking = false;
		const bar = document.getElementById('venture-cta-bar');
		if (!bar) {
			return;
		}

		const sections = document.querySelectorAll('.shopify-section.venture-section');
		const third = sections[2];
		let show = false;
		if (mobileMq.matches) {
			show = Boolean(third && third.getBoundingClientRect().top < window.innerHeight);
		} else if (third) {
			show = third.getBoundingClientRect().top < window.innerHeight;
		}
		bar.classList.toggle('is-visible', show);
		bar.setAttribute('aria-hidden', show ? 'false' : 'true');
	}

	function onScroll() {
		if (ticking) {
			return;
		}
		ticking = true;
		window.requestAnimationFrame(update);
	}

	if (!ventureCtaBarBound) {
		ventureCtaBarBound = true;
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll, { passive: true });
		mobileMq.addEventListener('change', update);
	}
	update();
}

document.addEventListener('DOMContentLoaded', initVentureCtaBar);
document.addEventListener('shopify:section:load', function (event) {
	if (event.target.querySelector('#venture-cta-bar') || event.target.id === 'venture-cta-bar') {
		initVentureCtaBar();
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venture-hero"] && !Shopify.designMode) return;
  try {
    
/* Triggers the layered reveal animation for venture-hero sections the
   first time each one scrolls into view, then drives a scroll-away parallax:
   once the entry animation finishes, the text and center image follow
   --exit-progress (0 in view -> 1 scrolled away). */

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// Fraction of the section's height the user scrolls through before the exit
// (rotate/slide) is complete. Smaller = the helmet rotates up sooner, while
// the section is still largely in view.
const EXIT_TRAVEL = 0.5;

// Live set of parallax-enabled sections driven by a single shared listener so
// re-initializing (e.g. in the theme editor) never stacks duplicate handlers.
const parallaxSections = new Set();
let ticking = false;
let listenersBound = false;

function updateParallax() {
  ticking = false;
  parallaxSections.forEach((section) => {
    // Drop sections that were removed (theme editor swaps the DOM node).
    if (!document.body.contains(section)) {
      parallaxSections.delete(section);
      return;
    }
    const rect = section.getBoundingClientRect();
    const height = rect.height || 1;
    let progress = -rect.top / (height * EXIT_TRAVEL);
    if (progress < 0) progress = 0;
    else if (progress > 1) progress = 1;
    section.style.setProperty('--exit-progress', progress.toFixed(4));
  });
}

function onScroll() {
  if (!ticking) {
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  }
}

function bindGlobalListeners() {
  if (listenersBound) return;
  listenersBound = true;
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
}

function setupReveal(section) {
  if (section.classList.contains('is-revealed')) return;
  if (!('IntersectionObserver' in window)) {
    section.classList.add('is-revealed');
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.25 }
  );
  observer.observe(section);
}

function setupParallax(section) {
  if (reduceMotion.matches) return;
  if (section.dataset.parallax !== 'true') return;
  if (parallaxSections.has(section)) return;

  // Hand off from the entry animation to scroll control once it has finished.
  const isDesktop = window.matchMedia('(min-width: 1001px)').matches;
  const center = isDesktop
    ? section.querySelector('.venture-hero__center--desktop')
    : section.querySelector('.venture-hero__center--mobile');
  if (center) {
    center.addEventListener(
      'animationend',
      () => section.classList.add('is-entered'),
      { once: true }
    );
  } else {
    section.classList.add('is-entered');
  }

  parallaxSections.add(section);
  bindGlobalListeners();
  onScroll();
}

function applyDesktopHeroHeight(hero) {
  const wrapper = hero.closest('.shopify-section.venture-hero');
  const height = `${window.visualViewport?.height ?? window.innerHeight}px`;

  hero.style.height = height;
  hero.style.minHeight = height;
  if (wrapper) {
    wrapper.style.height = height;
    wrapper.style.minHeight = height;
  }
}

function setDesktopHeroHeight(hero) {
  const wrapper = hero.closest('.shopify-section.venture-hero');
  const isDesktop = window.matchMedia('(min-width: 1001px)').matches;

  if (!isDesktop) {
    hero.style.removeProperty('height');
    hero.style.removeProperty('min-height');
    if (wrapper) {
      wrapper.style.removeProperty('height');
      wrapper.style.removeProperty('min-height');
    }
    return;
  }

  // Lock to the full viewport once on load. The fixed venture header sits on top
  // of the hero, so the section must be as tall as the screen.
  requestAnimationFrame(() => applyDesktopHeroHeight(hero));
}

function initSection(section) {
  if (!section) return;
  if (section.classList.contains('shopify-section')) return;

  setDesktopHeroHeight(section);
  setupReveal(section);
  setupParallax(section);
}

function initVentureHero(root) {
  (root || document)
    .querySelectorAll('.venture-hero')
    .forEach(initSection);
}

document.addEventListener('DOMContentLoaded', () => initVentureHero(document));

window.addEventListener(
  'load',
  () => {
    if (!window.matchMedia('(min-width: 1001px)').matches) return;
    document
      .querySelectorAll('.venture-hero:not(.shopify-section)')
      .forEach(applyDesktopHeroHeight);
  },
  { once: true }
);

// Re-initialize when the theme editor re-renders a section so live setting
// changes (reveal distance, offsets, etc.) actually replay.
document.addEventListener('shopify:section:load', (event) => {
  initVentureHero(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venture-media-with-info"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
	document
		.querySelectorAll('.venture-changeable-content-sides')
		.forEach(function initChecklistChangeableContent(changeableContentContainer) {
			const checklistItems = changeableContentContainer.querySelectorAll('.checklist-item');
			const checklistContentGroups = changeableContentContainer.querySelectorAll(
				'.info-related-checklist-item-group'
			);

			if (!checklistItems.length || !checklistContentGroups.length) {
				return;
			}

			checklistItems[0].classList.add('active');
			checklistContentGroups[0].classList.add('active');

			checklistItems.forEach(function (checklistItem, checklistItemIndex) {
				checklistItem.addEventListener('click', function () {
					checklistItems.forEach(function (item, itemIndex) {
						item.classList.toggle('active', itemIndex === checklistItemIndex);
					});
					checklistContentGroups.forEach(function (contentGroup, contentGroupIndex) {
						contentGroup.classList.toggle('active', contentGroupIndex === checklistItemIndex);
						if (
							window.matchMedia('(max-width: 1000px)').matches &&
							contentGroup.classList.contains('active')
						) {
							scrollElementIntoViewWithinParent(contentGroup, contentGroup.parentElement, 'smooth');
						}
					});
				});
			});
			initMobileIntersectionObserver(checklistItems, checklistContentGroups);
		});

	// Scroll only container. Safari support.
	function scrollElementIntoViewWithinParent(target, parent, behavior = 'smooth') {
		const parentRect = parent.getBoundingClientRect();
		const targetRect = target.getBoundingClientRect();
		const targetTopRelativeToParent = targetRect.top - parentRect.top;
		const targetCenterY = targetTopRelativeToParent + targetRect.height / 2;
		const parentCenterY = parentRect.height / 2;
		const newScrollTop = parent.scrollTop + targetCenterY - parentCenterY;
		const targetLeftRelativeToParent = targetRect.left - parentRect.left;
		const targetCenterX = targetLeftRelativeToParent + targetRect.width / 2;
		const parentCenterX = parentRect.width / 2;
		const newScrollLeft = parent.scrollLeft + targetCenterX - parentCenterX;

		parent.scrollTo({
			top: newScrollTop,
			left: newScrollLeft,
			behavior: behavior,
		});
	}

	function initMobileIntersectionObserver(checklistItems, checklistContentGroups) {
		const parentElement = checklistContentGroups[0].parentElement;
		let isScrollingProgrammatically = false;

		const observerOptions = {
			root: parentElement,
			rootMargin: '0px -40% 0px -40%',
			threshold: [0, 0.5, 1],
		};

		const observer = new IntersectionObserver(function (observerEntries) {
			// Prevent if not on mobile or during programmatic scrolls
			if (!window.matchMedia('(max-width: 1000px)').matches || isScrollingProgrammatically) return;

			// Find the most visible/centered content group
			let mostVisible = null;
			let maxVisibility = 0;

			observerEntries.forEach(function (entry) {
				if (entry.isIntersecting) {
					const visibility = entry.intersectionRatio;
					if (visibility > maxVisibility) {
						maxVisibility = visibility;
						mostVisible = entry.target;
					}
				}
			});

			if (mostVisible) {
				const activeIndex = Array.from(checklistContentGroups).indexOf(mostVisible);
				if (activeIndex !== -1) {
					checklistItems.forEach(function (item, itemIndex) {
						item.classList.toggle('active', itemIndex === activeIndex);
					});
					checklistContentGroups.forEach(function (contentGroup, contentGroupIndex) {
						contentGroup.classList.toggle('active', contentGroupIndex === activeIndex);
					});
				}
			}
		}, observerOptions);

		checklistContentGroups.forEach(function (contentGroup) {
			observer.observe(contentGroup);
		});

		// Flag to prevent observer updates during programmatic scrolls
		checklistItems.forEach(function (checklistItem) {
			checklistItem.addEventListener('click', function () {
				isScrollingProgrammatically = true;
				setTimeout(function () {
					isScrollingProgrammatically = false;
				}, 250);
			});
		});
	}
});

  } catch(e) { console.error(e); }
})();
})();
